<template>
  <div class="border-b catalog flex justify-between pb-4 mb-4">
    <div class="catalog__action mt-8">
      <i v-show="level !== 1 && isNewCatalog" @click="remove" class="cursor-pointer el-icon-remove-outline text-2xl"></i>
      <span v-if="!loading">
        <i v-show="level !== 1 && !isNewCatalog" @click="deleteCatalog" class="cursor-pointer el-icon-delete text-red-500 text-2xl"></i>
      </span>
      <vue-loaders v-if="action === 'edit' && loading" name="line-scale-pulse-out-rapid" color="red" scale="0.5"></vue-loaders>
    </div>
    <div class="catalog__select mb-4">
      <label class="block text-gray-700 text-sm mb-1">
        Category
      </label>
      <el-select class="w-full" v-model="categoryId" @change="categoryOnChange()" placeholder="Select Category">
        <el-option
          v-for="category in categories"
          :key="category.value"
          :label="category.label"
          :value="category.value">
        </el-option>
      </el-select>
      <p v-if="!$v.categoryId.required" class="text-red-500 text-xs italic mt-1">Category is required</p>
    </div>
    <div class="catalog__select mb-4">
      <label class="block text-gray-700 text-sm mb-1">
        Sub-Category
      </label>
      <el-select class="w-full" v-model="subCategoryId" @change="subCategoryOnChange()" placeholder="Select Sub Category">
        <el-option
          v-for="category in subCategories"
          :key="category.value"
          :label="category.label"
          :value="category.value">
        </el-option>
      </el-select>
    </div>
    <div class="catalog__select mb-4">
      <label class="block text-gray-700 text-sm mb-1">
        Micro-Category
      </label>
      <el-select class="w-full" v-model="microCategoryId" placeholder="Select Micro Category">
        <el-option
          v-for="category in microCategories"
          :key="category.value"
          :label="category.label"
          :value="category.value">
        </el-option>
      </el-select>
    </div>
    <div class="catalog__action mt-8">
      <i  v-show="count === level && $v.categoryId.required" @click="add()" class="cursor-pointer el-icon-circle-plus-outline text-2xl"></i>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import productForm from '../../../../helper/form-validations';

export default {
  name: 'Catalog',
  props: {
    count: {
      type: Number,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
    action: {
      type: String,
      default: 'create',
    },
  },
  mixins: [validationMixin],
  validations: {
    ...productForm.catalog,
  },
  data() {
    return {
      sub_disabled: true,
      micro_disabled: true,
      loading: false,
    };
  },
  computed: {
    key() {
      return this.level - 1;
    },

    categoryId: {
      get() {
        if (this.$store.state.InventoryModule.Products[this.action].catalog[this.key]) {
          return this.$store.state.InventoryModule.Products[this.action].catalog[this.key].category_id;
        }

        return null;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductMultipleData', {
          action: this.action, parent: 'catalog', key: this.key, property: 'category_id', payload: value,
        });
        this.$emit('isDirty', !this.$v.categoryId.$invalid);
      },
    },

    subCategoryId: {
      get() {
        if (this.$store.state.InventoryModule.Products[this.action].catalog[this.key]) {
          return this.$store.state.InventoryModule.Products[this.action].catalog[this.key].sub_category_id;
        }

        return null;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductMultipleData', {
          action: this.action, parent: 'catalog', key: this.key, property: 'sub_category_id', payload: value,
        });
      },
    },

    microCategoryId: {
      get() {
        if (this.$store.state.InventoryModule.Products[this.action].catalog[this.key]) {
          return this.$store.state.InventoryModule.Products[this.action].catalog[this.key].micro_category_id;
        }

        return null;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductMultipleData', {
          action: this.action, parent: 'catalog', key: this.key, property: 'micro_category_id', payload: value,
        });
      },
    },

    categories() {
      return this.$store.getters['InventoryModule/Catalog/getCategoryForSelect'];
    },

    subCategories() {
      if (this.categoryId) {
        return this.$store.getters['InventoryModule/Catalog/getSubCategoryForSelect'](this.categoryId);
      }

      return [];
    },

    microCategories() {
      if (this.subCategoryId) {
        return this.$store.getters['InventoryModule/Catalog/getMicroCategoryForSelect'](this.subCategoryId);
      }

      return [];
    },

    isNewCatalog() {
      const catalog = this.$store.state.InventoryModule.Products[this.action].catalog[this.key];
      if (catalog && Object.keys(catalog).length > 0) {
        return !catalog.id;
      }

      return true;
    },
  },
  methods: {
    add() {
      this.$store.commit('InventoryModule/Products/setActionMultipleProperty', {
        action: this.action, parent: 'catalog', payload: { [this.level]: {} },
      });
      this.$emit('add');
    },
    async remove() {
      await this.$store.commit('InventoryModule/Products/removeProductMultipleData', {
        action: this.action, parent: 'catalog', key: this.key, index: this.level,
      });
      this.$emit('minus');
    },
    categoryOnChange() {
      this.sub_disabled = false;
      this.$store.commit('InventoryModule/Products/setProductMultipleData', {
        action: this.action, parent: 'catalog', key: this.key, property: 'sub_category_id', payload: null,
      });
    },
    subCategoryOnChange() {
      this.micro_disabled = false;
      this.$store.commit('InventoryModule/Products/setProductMultipleData', {
        action: this.action, parent: 'catalog', key: this.key, property: 'micro_category_id', payload: null,
      });
    },
    async deleteCatalog() {
      this.loading = true;
      const catalogId = this.$store.state.InventoryModule.Products[this.action].catalog[this.key].id;
      try {
        await this.$store.dispatch('InventoryModule/Products/deleteItemCatalog', { catalogId, productId: this.$route.params.id });
        await this.remove();
        this.$notify.success({
          title: 'Success',
          message: 'Catalog Successfully Deleted',
        });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
      this.loading = false;
    },
  },
  mounted() {
    this.$emit('isDirty', !this.$v.categoryId.$invalid);
  },
};
</script>

<style scoped lang="scss">
  .catalog {
    .catalog__select {
      flex: 0 1 30%
    }

    .catalog__action {
      flex: 0 1 3%;
    }
  }
</style>
